<div class="w-full relative">
  <div
    class="overflow-x-auto z-10 w-full no-scrollbar flex justify-start sm:justify-start overflow-visible"
    style="scroll-snap-type: x proximity; overflow-y: visible; padding-left: 0"
    >
    <div class="flex flex-nowrap space-x-2 sm:space-x-3 px-2 sm:px-3 pb-1 w-max">
      <!-- All Categories option -->
      <div
        class="snap-start flex-shrink-0 rounded-3xl text-center border shadow-md p-1 sm:p-3 w-28 sm:w-36 cursor-pointer hover:shadow-lg transition-all duration-300 relative mb-20"
        (click)="selectAllCategories()"
        [class.bg-yellow-500]="selectedCategoryId === null"
        [class.text-white]="selectedCategoryId === null"
        [class.bg-white]="selectedCategoryId !== null"
        [class.border-yellow-300]="selectedCategoryId !== null"
        [class.border-yellow-500]="selectedCategoryId === null"
        [class.shadow-lg]="selectedCategoryId === null"
        >
        <div class="flex items-center justify-between">
          <h3 class="font-medium truncate flex-1 text-xs sm:text-sm"
          [class.text-gray-800]="selectedCategoryId !== null"
          [class.text-white]="selectedCategoryId === null">
            Todas las categorías
          </h3>
        </div>
      </div>

      @for (category of categories; track category) {
        <div
          class="cursor-pointer snap-start flex-shrink-0 rounded-3xl text-center border-2 shadow-md p-1 sm:p-3 min-w-[100px] sm:min-w-[140px] hover:shadow-lg transition-all duration-300 relative mb-20"
          (click)="onCategorySelect(category.pg_id)"
          [class.bg-yellow-500]="selectedCategoryId === category.pg_id"
          [class.text-white]="selectedCategoryId === category.pg_id"
          [class.bg-white]="selectedCategoryId !== category.pg_id"
          [class.border-yellow-300]="selectedCategoryId !== category.pg_id"
          [class.border-yellow-00]="selectedCategoryId === category.pg_id"
          [class.shadow-lg]="selectedCategoryId === category.pg_id"
          >
          <div class="flex items-center justify-between">
            <h3 class="font-medium truncate flex-1 text-xs sm:text-sm"
                [class.text-gray-800]="selectedCategoryId !== category.pg_id"
                [class.text-white]="selectedCategoryId === category.pg_id">
              {{ category.pg_name }}
            </h3>
            <!-- Flecha temporalmente quitada como solicitado -->
          </div>
          <!-- Subcategories dropdown - Temporalmente comentado como solicitado -->
          <!-- <div
          *ngIf="selectedCategoryId === category.pg_id"
          class="absolute left-0 right-0 mt-1 z-50 bg-white rounded-xl shadow-lg border border-yellow-200 no-scrollbar"
          style="
            width: 100%;
            top: calc(100% + 6px);
            max-height: 180px;
            overflow-y: auto;
            transform: translateY(0);
          "
          >
          <div class="py-1">
            <establishment-main-list-subcategories
              [categoryId]="category.pg_id"
              (subcategorySelected)="onSubcategorySelected($event)"
            ></establishment-main-list-subcategories>
          </div>
        </div> -->
      </div>
    }

    <!-- Mensaje cuando no hay categorías -->
    @if (categories.length === 0) {
      <div class="w-full text-center py-4">
        <!-- <p class="text-gray-500">No hay categorías disponibles</p> -->
      </div>
    }
  </div>
</div>
</div>


